module.exports = __webpack_public_path__ + "static/media/scout.4ff11855.svg";